import config from './config';

/**
 * UI - цвета
 *
 * @type {Object}
 */
export const UI_COLORLS = {
    black:          '#000000',
    blackPrimary:   '#1c1819',
    blueDarker:     '#0066cc',
    blueDarkest:    '#00458a',
    blueLight:      '#34a2e9',
    blueLighter:    '#d6ecfb',
    bluePrimary:    '#2a81dd',
    gray:           '#888b94',
    grayDarker:     '#414247',
    grayLighter:    '#bbbec9',
    grayLightest:   '#d4d4da',
    green:          '#64bd38',
    greenLight:     '#a1e480',
    orange:         '#ff7733',
    payedBlue:      '#e9f2fb',
    payedGreen:     '#eff8eb',
    payedRed:       '#ffeaea',
    payedYellow:    '#fffae7',
    red:            '#ff3333',
    white:          '#ffffff',
    whiteDarker:    '#fafafa',
    whiteDarkest:   '#f2f2f3',
    yellow:         '#ffd313',
    yellowDarker:   '#ffc726',
    yellowLightest: '#fde8a3',
    yellowPrimary:  '#ffdd61',
};

/**
 * Новые статусы для лидов
 * 1 - Целевой; 2 - Нецелевой; 3 - Апеляция; 4 - Повтор
 */
export const newStatuses = {
    APPEAL:      3,
    DUPLICATE:   4,
    TARGET:      1,
    UNEARMARKED: 2,
};

/**
 * Новые тип оплаты
 * 1 - Оплачен; 2 - Неоплачен;
 */
export const paymentType = {
    NOT_PAID: 2,
    PAID:     1,
};

/**
 * Типы заявки
 * 1 - Звонок; 2 - Форма обратного вызыова ; 3 - Пропушенный звогок;
 */
export const requestTypes = {
    CALL:   1,
    FORM:   2,
    MISSED: 3,
};

/**
 * Статусы звонков
 *
 * @type {{SUCCESS: number, FAILED: number}}
 */
export const callStatuses = {
    FAILED:  2,
    SUCCESS: 1,
};

/**
 * Коды статусов (с бэка), при которых в списке лидов доступна кнопка апелляции.
 * 1, 3, 32 — целевой (подать апелляцию); 7 — уже на апелляции (снять).
 */
export const appealAvailableStatuses = [1, 3, 32, 7];

/**
 * Новые статусы для лидов
 * 1 - Целевой; 2 - Нецелевой; 3 - Апеляция; 4 - Повтор
 */
export const leadStatuses = {
    1:  newStatuses.TARGET,
    3:  newStatuses.TARGET,
    30: newStatuses.UNEARMARKED,
    31: newStatuses.DUPLICATE,
    32: newStatuses.TARGET,
    7:  newStatuses.APPEAL,
};

/**
 * Новые тип оплаты
 * 1 - Оплачен; 2 - Неоплачен;
 */
export const leadPayments = {
    1:  paymentType.PAID,
    3:  paymentType.PAID,
    30: paymentType.PAID,
    31: paymentType.NOT_PAID,
    32: paymentType.NOT_PAID,
    7:  paymentType.PAID,
};

/**
 * Ключи словаря с текстами новых статусов.
 * Тут ключи, а не тексты: constants.js подключает tailwind.config.js в Node, без i18n
 */
export const leadStatusesTextKeys = {
    [newStatuses.TARGET]:      'leads.statuses.target',
    [newStatuses.UNEARMARKED]: 'leads.statuses.unearmarked',
    [newStatuses.APPEAL]:      'leads.statuses.appeal',
    [newStatuses.DUPLICATE]:   'leads.statuses.duplicate',
};

/**
 * Ключи словаря с текстами типов оплаты
 */
export const leadPaymentTextKeys = {
    [paymentType.PAID]:     'leads.payments.paid',
    [paymentType.NOT_PAID]: 'leads.payments.notPaid',
};

/**
 * Тема для фона чипсов статусов лидов
 */
export const leadStatusesTheme = {
    [newStatuses.TARGET]:      'green',
    [newStatuses.UNEARMARKED]: 'black',
    [newStatuses.APPEAL]:      'yellow',
    [newStatuses.DUPLICATE]:   'gray',
};

/**
 * Цвет текста для новых статусов
 */
export const leadStatusesColors = {
    [newStatuses.TARGET]:      '#ffffff',
    [newStatuses.UNEARMARKED]: '#ffffff',
    [newStatuses.APPEAL]:      '#ffffff',
    [newStatuses.DUPLICATE]:   '#414247',
};

// Типы юзера
export const userTypes = {

    // Тип юзера - Trade-in
    3: 'complex',

    // Тип юзера - Новые Авто
    4: 'complex',

    // Тип юзера - застройщик
    5: 'builder',
};

/**
 * Ответ сервера без авторизауионного ключа
 *
 * @type {number}
 */
export const STATUS_NO_TOKEN = 401;

/**
 * Путь к api
 *
 * @type {string}
 */
export const API_URL = config.api;

/**
 * Путь к разлогину через api
 *
 * @type {string}
 */
export const LOGIN_REDIRECT_URL = `${API_URL}/login-redirect`;

/**
 * Проверка ролей пользователя
 *
 * @todo в будущем будет дорабатываться
 *
 * @param {String} role - Роль на проверку
 * @param {String} currentRole - текущая роль в системе
 * @return {Boolean}
 */
export const checkRole = (role, currentRole) => {
    if (currentRole === userTypes[4] && role === userTypes[4]) return true;

    if (currentRole === userTypes[5] && (role === userTypes[4] || role === userTypes[5])) return true;

    return false;
};
